/**
 * @generated SignedSource<<5dc225187a043b1efedbd9071b30ba17>>
 * @relayHash 700456e5410e09f8ea2022ddce7d1fe6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f83d6f5c4555d92d62905bf6c524f61f7441de0d6a2f50fec25f756c75482af0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubDetailsPageQuery } from './ServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f83d6f5c4555d92d62905bf6c524f61f7441de0d6a2f50fec25f756c75482af0",
    "metadata": {},
    "name": "ServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
